module.exports = __webpack_public_path__ + "img/home_pie_chart_fr.3f03899.png";